<template>
    <div>
        <div :class="componentName === 'FilmView' ? 'film_view_component' : ''" v-if="!loading && project !== null">
            <p class="back_link">
                <a :href="back_link">
                    <svg width="14.000000" height="11.000000" viewBox="0 0 14 11" fill="none"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path id="Vector 1 (Border)"
                              d="M2.65796 6.32568L5.72949 9.58704C6.03735 9.91406 6.03735 10.4279 5.72949 10.7548C5.42139 11.0818 4.93774 11.0818 4.62964 10.7548L0.230957 6.08386C-0.0769043 5.75696 -0.0769043 5.24304 0.230957 4.91614L4.62964 0.245239C4.93774 -0.0817871 5.42139 -0.0817871 5.72949 0.245239C6.03735 0.572144 6.03735 1.08594 5.72949 1.41296L2.65796 4.67432L13.2224 4.67432C13.658 4.67432 14 5.0376 14 5.5C14 5.9624 13.658 6.32568 13.2224 6.32568L2.65796 6.32568Z"
                              fill="#EC983F" fill-opacity="1.000000" fill-rule="evenodd"/>
                    </svg>
                    <span>Киностудия {{ project.user.firm_name }}</span></a>
            </p>
            <div class="columns">
                <div class="column">
                    <div class="header_title">{{ project.name }}</div>


                    <p v-if="currentUserId == '15198'">
                        <Checkbox
                                v-model:checked="project.projectData.moviestart_distr"
                                @change="patchProject"
                        >
                            для продажи Moviestart distribution
                        </Checkbox>
                    </p>


                    <div class="columns ">
                        <div class="column afisha_column is-narrow">
<!--                            <img :src="'https://script.moviestart.ru/uploads/images/'+project.afisha" alt="">-->
														<ImageRender
																		:src="getProjectAvatar(project.afisha)"
														></ImageRender>

                            <div class="columns production_block">
                                <div class="column project_logo">
<!--                                    <img :src="'https://script.moviestart.ru/uploads/images/user/'+project.user.logo"-->
<!--                                         alt="">-->
																		<ImageRender
																						:src="getUserAvatar('user/' + project.user.logo)"
																		></ImageRender>

                                </div>
                                <div class="column ">
                                    <p v-if="project.production" class="countries_block__title">Производство</p>
                                    <p v-if="project.production" class="countries_block__sub">{{
																				project.production
                                        }}</p>

                                    <p v-if="project.projectData?.production_country" class="countries_block__title">
                                        Страна производства</p>
                                    <p v-if="project.projectData?.production_country" class="countries_block__sub">
                                        {{ project.projectData.production_country.join(',') }}</p>

                                </div>
                            </div>
                        </div>
                        <div class="column">

                            <div class="countries_block">
                                <div class="columns">
                                    <div class="column is-narrow">
                                        <div class="columns">
                                            <div class="column" v-if="project.category">
                                                <p class="countries_block__title">Формат</p>
                                                <p class="countries_block__sub">{{ project.category }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="project.zhanr" class="column is-narrow">
                                        <p class="countries_block__title">Жанр</p>
                                        <p class="countries_block__sub">{{ joinedKeys(project.zhanr) }}</p>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div class="column is-narrow">
                                        <div class="columns">
                                            <div class="column" v-if="project.publishYear">
                                                <p class="countries_block__title">Год выпуска</p>
                                                <p class="countries_block__sub">{{ project.publishYear }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="project.chronometr" class="column is-narrow">
                                        <p class="countries_block__title">Хронометраж</p>
                                        <p class="countries_block__sub">{{ project.chronometr }}</p>
                                    </div>
                                    <div v-if="project.projectData?.age_limit" class="column is-narrow">
                                        <p class="countries_block__title">Возрастное ограничение</p>
                                        <p class="countries_block__sub">{{ project.projectData.age_limit }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="countries_block" v-if="isOrganizator">
                                <div class="columns">
                                    <div class="column is-narrow">
                                        <div class="columns">
                                            <div class="column is-narrow" style="align-items: center; display: flex">
                                                <svg width="27.999939" height="35.000000" viewBox="0 0 27.9999 35"
                                                     fill="none" xmlns="http://www.w3.org/2000/svg"
                                                     xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <path id="Vector"
                                                          d="M13.9999 0C6.26801 0 0 6.26813 0 14C0 21.7319 13.9999 35 13.9999 35C13.9999 35 27.9999 21.7319 27.9999 14C27.9999 6.26813 21.7319 0 13.9999 0ZM13.9999 3.81824C15.337 3.81824 16.6611 4.08148 17.8964 4.5932C19.1317 5.10486 20.2541 5.8548 21.1996 6.80029C22.145 7.74579 22.895 8.86823 23.4067 10.1036C23.9184 11.3389 24.1818 12.663 24.1818 14C24.1818 15.3371 23.9184 16.6611 23.4067 17.8964C22.895 19.1317 22.145 20.2542 21.1996 21.1996C20.2541 22.1451 19.1317 22.895 17.8964 23.4067C16.6611 23.9184 15.337 24.1818 13.9999 24.1818C12.6628 24.1818 11.3389 23.9184 10.1036 23.4067C8.86823 22.895 7.74579 22.1451 6.80035 21.1996C5.85486 20.2542 5.10492 19.1317 4.5932 17.8964C4.08154 16.6611 3.81818 15.3371 3.81818 14C3.81818 12.663 4.08154 11.3389 4.5932 10.1036C5.10492 8.86823 5.85486 7.74579 6.80035 6.80029C7.74579 5.8548 8.86823 5.10486 10.1036 4.5932C11.3389 4.08148 12.6628 3.81824 13.9999 3.81824Z"
                                                          fill="#EC983F" fill-opacity="1.000000" fill-rule="nonzero"/>
                                                    <path id="Vector"
                                                          d="M17.7057 7.58569C17.6488 7.58453 17.5919 7.59113 17.5367 7.6051L9.51752 9.61108C9.43262 9.62744 9.35193 9.66095 9.2804 9.70959C9.20886 9.75818 9.14795 9.82086 9.10144 9.8938C9.05493 9.96674 9.0238 10.0485 9.00989 10.1339C8.99603 10.2192 8.99969 10.3064 9.02063 10.3903C9.04163 10.4742 9.07947 10.553 9.1319 10.6218C9.18433 10.6906 9.25024 10.748 9.32562 10.7905C9.40094 10.8329 9.48419 10.8596 9.57019 10.8688C9.65613 10.8781 9.74316 10.8696 9.82581 10.8441L17.8449 8.83801C17.9958 8.80194 18.1282 8.71198 18.2174 8.58508C18.3066 8.45819 18.3464 8.3031 18.3293 8.14899C18.3122 7.99481 18.2394 7.85217 18.1246 7.74792C18.0098 7.64368 17.8608 7.58789 17.7057 7.58569Z"
                                                          fill="#EC983F" fill-opacity="1.000000" fill-rule="nonzero"/>
                                                    <path id="Vector"
                                                          d="M9.22955 12.0908L9.22955 13.6817L18.775 13.6817L18.775 12.0908L9.22955 12.0908Z"
                                                          fill="#EC983F" fill-opacity="1.000000" fill-rule="nonzero"/>
                                                    <path id="Vector"
                                                          d="M9.22955 14.9547L9.22955 18.3553C9.22955 18.7623 9.55548 19.0911 9.95538 19.0911L18.0516 19.0911C18.4515 19.0911 18.775 18.7621 18.775 18.3553L18.775 14.9547L9.22955 14.9547Z"
                                                          fill="#EC983F" fill-opacity="1.000000" fill-rule="nonzero"/>
                                                </svg>
                                            </div>
                                            <div class="column">
                                                <p class="countries_block__title">Страна</p>
                                                <p class="countries_block__sub">{{ project.country }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column is-narrow">
                                        <p class="countries_block__title">Регион</p>
                                        <p class="countries_block__sub">{{ project.region }}</p>
                                    </div>
                                    <div class="column is-narrow">
                                        <p class="countries_block__title">Город</p>
                                        <p class="countries_block__sub">{{ project.city }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="countries_block">
                                <div class="columns">
                                    <div class="column is-narrow">
                                        <div class="columns" v-if="project.rezhiser">
                                            <div class="column">
                                                <p class="countries_block__title">Полное ФИО режиссера</p>
                                                <p class="countries_block__sub">{{ project.rezhiser }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div style="max-width: 100%" class="column is-narrow"
                                         v-if="project.projectData?.produser">
                                        <div class="columns">
                                            <div class="column">
                                                <p class="countries_block__title">Полное ФИО продюсера</p>
                                                <p class="countries_block__sub">{{ project.projectData?.produser }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div style="max-width: 100%" class="column is-narrow">
                                        <div class="columns" v-if="project.projectData?.inroles">
                                            <div class="column">
                                                <p class="countries_block__title">Исполнители главных ролей/герои</p>
                                                <p class="countries_block__sub">{{ project.projectData.inroles }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns" v-if="project.projectData?.finance_sources  && isOrganizator">
                                    <div class="column is-narrow">
                                        <div class="columns">
                                            <div class="column">
                                                <p class="countries_block__title">Источники финансирования фильма</p>
                                                <p class="countries_block__sub">{{
																										project.projectData.finance_sources
                                                    }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns" v-if="project.projectData?.budget && isOrganizator">
                                    <div class="column is-narrow">
                                        <div class="columns">
                                            <div class="column">
                                                <p class="countries_block__title">Бюджет фильма</p>
                                                <p class="countries_block__sub">{{ project.projectData.budget }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns" v-if="project.prioritySocial && isOrganizator">
                                    <div class="column is-narrow">
                                        <div class="columns">
                                            <div class="column">
                                                <p class="countries_block__title">Съемочная группа</p>
                                                <p class="countries_block__sub">{{ project.prioritySocial }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="countries_block">
                                <div class="columns">
                                    <div class="column">
                                        <div class="columns" v-if="project.annotation">
                                            <div class="column">
                                                <p class="countries_block__title">Аннотация</p>
                                                <div class="countries_block__sub" v-html="project.annotation"></div>
                                            </div>
                                        </div>

                                        <div class="columns"
                                             v-if="project.projectData?.short_annotation && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Краткая аннотация</p>
                                                <p class="countries_block__sub"
                                                   v-html="project.projectData.short_annotation"></p>
                                            </div>
                                        </div>


                                        <div class="columns" v-if="project.projectData?.tsitata  && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Цитата авторов фильма (продюсера,
                                                    режиссера) - для пресс-клипинга</p>
                                                <p class="countries_block__sub">{{ project.projectData.tsitata }}</p>
                                            </div>
                                        </div>

                                        <div class="columns" v-if="project.projectData?.uniq && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">В чем уникальность фильма</p>
                                                <p class="countries_block__sub">{{ project.projectData.uniq }}</p>
                                            </div>
                                        </div>

                                        <div class="columns" v-if="project.projectData?.uniq">
                                            <div class="column">
                                                <p class="countries_block__title">Участие в питчингах, конкурсах,
                                                    фестивалях</p>
                                                <p class="countries_block__sub">{{ project.projectData.ychastie }}</p>
                                            </div>
                                        </div>

                                        <div class="columns" v-if="project.projectData?.poster_link  && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Ссылка на скачивание постера
                                                    фильма</p>
                                                <p class="countries_block__sub"><a
                                                        :href="project.projectData?.poster_link"
                                                        target="_blank">{{ project.projectData?.poster_link }}</a></p>
                                            </div>
                                        </div>

                                        <div class="columns" v-if="project.tagline && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Ссылка на скачивание кадров из
                                                    фильма</p>
                                                <p class="countries_block__sub"><a :href="project.tagline"
                                                                                   target="_blank">{{
																										project.tagline
                                                    }}</a></p>
                                            </div>
                                        </div>


                                        <div class="columns" v-if="project.projectData?.foto_links  && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Ссылка на скачивание фотографий со
                                                    съемок фильма</p>
                                                <p class="countries_block__sub"><a
                                                        :href="project.projectData?.foto_links"
                                                        target="_blank">{{ project.projectData?.foto_links }}</a></p>
                                            </div>
                                        </div>

                                        <div class="columns"
                                             v-if="project.projectData?.regiserBiografy && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Биография режиссера</p>
                                                <p class="countries_block__sub"
                                                   v-html="project.projectData?.regiserBiografy"></p>
                                            </div>
                                        </div>


                                        <div class="columns" v-if="project.logline && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Фильмография режиссера</p>
                                                <p class="countries_block__sub" v-html="project.logline"></p>
                                            </div>
                                        </div>

                                        <div class="columns" v-if="project.filmLanguage && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Номер прокатного удостоверения</p>
                                                <p class="countries_block__sub">{{ project.filmLanguage }}</p>
                                            </div>
                                        </div>

                                        <div class="columns" v-if="project.projectData?.treiler">
                                            <div class="column">
                                                <BaseVideoLinkRender
                                                        label="Ссылка на трейлер"
                                                        v-model:value="project.projectData.treiler"
                                                ></BaseVideoLinkRender>
                                            </div>
                                        </div>


                                        <!--                                        <div class="columns" v-if="project.motivation && isOrganizator">-->
                                        <!--                                            <div class="column">-->
                                        <!--                                                <p class="countries_block__title">Формат фильма для показа</p>-->
                                        <!--                                                <p class="countries_block__sub">{{ project.motivation }}</p>-->
                                        <!--                                            </div>-->
                                        <!--                                        </div>-->

                                        <div class="columns" v-if="project.videoLink  && isOrganizator">
                                            <div class="column">
                                                <p class="countries_block__title">Ссылка для просмотра</p>
                                                <p class="countries_block__sub"><a :href="project.videoLink"
                                                                                   target="_blank">{{
																										project.videoLink
                                                    }}</a></p>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div v-else>
            <div style="text-align: center">
                <Spin></Spin>
            </div>
        </div>

    </div>
</template>
<script>

export default {
  name: "FilmView",
  data() {
    return {
      componentName: this.$options.name // Используем $options.name для получения имени компонента
    };
  }
};
</script>

<script setup>
import axios from "axios";
import {ref, computed} from "vue";
import {Spin, Checkbox} from "ant-design-vue"
import BaseVideoLinkRender from "@/components/Base/BaseVideoLinkRender.vue";
import Json from "@/services/json";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

let loading = ref(true);
let project = ref({
  projectData: {
    moviestart_distr: false
  }
});
// const instance = getCurrentInstance();
// console.log(instance);
// const componentName = instance.type.__name || 'Unknown';

function joinedKeys(array) {
  if (array && Array.isArray(array)) {
    return array.join(', ')
  }
  return '';
}

const isOrganizator = computed(() => {
  return window.isOrganizatorRole == '1';
})

function handleEntityResponse(projects_response) {
  projects_response.data = Json.replaceKeys(projects_response.data);
  projects_response.data.projectData = Json.handle_json_field(projects_response.data.projectData, project.value.projectData);
  project.value = projects_response.data;
  loading.value = false;
}

async function getData() {
  loading.value = true;
  const projects_response = await axios.get('/project/getFilm/' + window.film_id);
  handleEntityResponse(projects_response)
}

getData();

let currentUserId = ref(window.currentUserId);

async function patchProject() {
  const project_object = structuredClone(project.value);
  delete project_object.user;
  delete project_object.afisha;

  if (project_object.publishYear?.length === 0) {
    delete project_object.publishYear;
  } else {
    project_object.publishYear = parseInt(project.value.publishYear)
  }

  const response = await axios.patch('/api/projects/' + project.value.id, project_object, {
    headers: {
      'Content-Type': "application/merge-patch+json"
    }
  }).catch((event) => {
    alert(event.response.data['hydra:description']);
  })
  handleEntityResponse(response);
}

const back_link = computed(() => {
  let res = '';
  if (project.value?.user?.id) {
    res = '/film_company/' + project.value?.user?.id;
  }

  // if (window.source === 'md') {
  //   res = '/moviestart_distribution';
  // }

  return res;
})

function getProjectAvatar(avatar) {
  return ImageService.getProjectImagePath(avatar);
}

function getUserAvatar(avatar) {
  return ImageService.getUserImagePath(avatar);
}

</script>
<style scoped>
.field__wrapper {
    margin-bottom: 20px;
}

.field_label {
    font-weight: bold;
}

.countries_block {
    background: rgb(247, 247, 247);
    border-radius: 12px;
    display: inline-block;
    padding: 20px;
    padding-bottom: 0;
    margin-bottom: 30px;
}

/*.countries_block > .columns > .column {*/
/*    margin-right: 30px;*/
/*}*/

.column .countries_block__title {
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 5px;
}

.countries_block__sub {
    font-weight: 500;
    margin-bottom: 0;
}

.afisha_column {
    width: 30%;
}

.countries_block {
    width: 100%;
}

.production_block {
    margin-top: 15px;
}

.project_logo:deep img {
    max-width: 125px;
}

.header_title {
    margin-bottom: 25px;
}

.countries_block .columns > .columns .column {
    padding: 0;
}

.countries_block > .columns {
    margin-bottom: 0;
}

.film_view_component .back_link {
    padding-left: 0;
}
.afisha_column:deep img, .project_logo:deep img {
    border-radius: 12px;
}

@media (max-width: 1300px) {
    .column.is-narrow {
        flex: auto;
    }
}

@media (max-width: 770px) {
    .afisha_column {
        width: 100%;
    }
}

</style>